import { Component, inject, OnInit } from '@angular/core';
import { StorageService } from '@tae/services';
import { PageViewInferface, SetEventInterface } from 'src/app/interfaces/tagging.interface';
import { BottomSheetService } from 'src/app/services/bottomSheet/bottom-sheet.service';
import { TaggingService } from 'src/app/services/tagging.service';

@Component({
    selector: 'app-sheet-deactivate',
    templateUrl: './sheet-deactivate.component.html',
    styleUrls: ['./sheet-deactivate.component.scss'],
    standalone: false
})
export class SheetDeactivateComponent implements OnInit {

  #bss = inject(BottomSheetService);

  #taggingService = inject(TaggingService);

  #storageService = inject(StorageService);

  data: any;

  ngOnInit(): void {
    const page: PageViewInferface = {
      url: 'recarga_celular/popup/no_te_quedes_sin_saldo',
      canalBanco: "supermovil",
      titulo: 'recarga_celular|popup|no_te_quedes_sin_saldo',
      subsection1: 'recarga_celular',
      userId: '',
      entorno: this.#storageService.get("ENV"),
      proceso: 'recarga_automatica',
      event: "PageView",
    }
    this.#taggingService.setPageView(page);
  }

  onClick(): void {
    this.#bss.hide();
    this.data.onContinue();
    const action: SetEventInterface = {
        event: "payments",
        categoria: "recarga_celular",
        accion: "popup_no_te_quedes_sin_saldo",
        etiqueta: `continuar`,
        canalBanco: "supermovil",
        url: "recarga_celular/popup/no_te_quedes_sin_saldo",
        userID: "",
      };
      this.#taggingService.setEvent(action);
  }

}
